<template>
        <v-parallax
         dark
          :src="myImage"
        >
  <p>
    <br>1st RULE: You do not talk about FILMKLUBB.
    <br>2nd RULE: You DO NOT talk about FILMKLUBB.
    <br>3rd RULE: If someone says "stop" or goes limp, taps out the FILM is over.
    <br>4th RULE: Only four½ guys to a FILM.
    <br>5th RULE: One FILM at a time.
    <br>6th RULE: No shirts, no shoes.
    <br>7th RULE: FILMS will go on as long as they have to.
  </p>
        </v-parallax>
</template>

<script>
export default {
  data: () => ({
    myImage: require('@/assets/film.jpg')
  })
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Root.vue